/** @format */

import process from "process";
import i18n from "../Langues/i18n";
import { ToastContainer, toast } from "react-toastify";
const API_BASE_URL = process.env.REACT_APP_API_URL;
/**
 * Met à jour les données pour une instance spécifique.
 * @param {string} token Le token d'authentification
 * @param {string} instanceId L'ID de l'instance à mettre à jour
 * @param {Object} updateData Les données à mettre à jour
 * @returns {Promise<Object>} Le résultat de l'appel d'API
 */
export async function updateInstanceData(
  token,
  instanceId,
  status,
  dDateRemise
) {
  //const url =  'https://api-imfdev.myactivhub.net/model/list';
  const url = API_BASE_URL + "/process/update/";

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        InstanceId: instanceId,
        FieldList: {
          dDateRemise: dDateRemise,
          sStatus: status,
        },
      }),
    });

    if (!response.ok) {
      alert("Mise à jour echoué");
      throw new Error(`Erreur API: ${response.status} ${response.statusText}`);
    } else {

      toast.success(i18n.t('instanceUpdatedSuccess'));
    }

    return await response.json(); 
  } catch (error) {
    console.error("Erreur lors de la mise à jour de l'instance:", error);
    throw error; 
  }
}
